<template>
    <div class="main" style="background-color: #f5f5ef">
        <template v-if="loaded">
            <div class="column0">
                <!--<nav class="navbar-fixed-top"><nav-header /></nav>-->
                <nav-header />
            </div>
            <div class="row">
                <div class="column1">
                    <menu-sidebar />
                </div>
                <div class="column2">
                    <router-view />
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import MenuSidebar from "../components/MenuSidebar";
import NavHeader from "../components/NavHeader";
import {mapState} from "vuex";

export default {
    components: {
        NavHeader,
        MenuSidebar
    },

    data: function() {
        return {
            loaded: false
        };
    },

    computed:{
        ...mapState({
            user:state=>{
                return state.Auth.user
            },
        })
    },

    created() {
        // this.loaded = true;
        // const auth = this.user
        // if (!auth) this.$router.push("/login");
        // else this.$store.dispatch("Products/getProductAll")
        this.$store
            .dispatch("Auth/setUser")
            .then(() => (this.loaded = true))
            .then(()=>{this.$store.dispatch("Products/getProductAll")})
            .catch(() => this.$router.push("/login"));
    }
};
</script>
<style>
    * {
        font-family: "Sarabun", Helvetica, Arial, sans-serif;
    }
</style>
<style lang="scss" scoped>
    @import "../assets/css/table.css";
    * {
        box-sizing: border-box;
    }
    .column1 {
        float: left;
        width: 20%;
        background: #5F5F5D;
        /*padding: 0 0 0 0.75em;*/
    }
    .column2 {
        float: left;
        width: 80%;
        padding: 30px;
        /*padding: 30px 60px 30px 30px;*/
        background-color:#f5f5ef;
        position:relative;
        height: 100vh;
        overflow-x:hidden;
        overflow-y:scroll;
    }
    .column0{
        width: 100%;
    }
    .row{
        margin-right: 0;
    }

    /* On screens that are 768 wide or less, make the columns stack on top of each other instead of next to each other */
    @media screen and (max-width: 800px) {
        .column1 {
            width: 100%;
        }
        .column2 {
            width: 100%;
            float: left;
            min-height: 140vh !important;
            overflow-y:auto !important;
            overflow-x:hidden;
        }
        .column0{
            width: 100%;
        }
    }

    /* On screens that are 1400 wide or less, make the columns stack on top of each other instead of next to each other */
    @media screen and (min-width: 1200px) {
        .column1 {
            width: 15%; //15
        }
        .column2 {
            width: 83%; //85
            float: left;
            overflow-y:auto;
            min-height: 100vh;
        }
        .column0{
            width: 100%;
        }
    }
</style>
